import { useSelector, useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { loadMoreData } from 'actions/home_bar/scope_dropdown'
import {
  isFilteringSelector,
  filterTermSelector,
  teamsSelector,
  hasMoreTeamsSelector
} from 'selectors/home_bar'

import AllScope from './all_scope'
import Header from './header'
import Item from './item'
import MenuGroup from './menu_group'
import ShowMore from './show_more'

const shouldShowAllScope = (isFiltering, isMeetings, isAdminOrOwner) => {
  if (isFiltering) return false
  if (isMeetings) return isAdminOrOwner
  return true
}

const TeamsList = ({ selectItem, canCreateTeam, isAdminOrOwner }) => {
  const dispatch = useDispatch()
  const isFiltering = useSelector(isFilteringSelector)
  const filterTerm = useSelector(filterTermSelector)
  const teams = useSelector(teamsSelector)
  const hasMoreTeams = useSelector(hasMoreTeamsSelector)
  const isMeetings = useRouteMatch('/app/meetings')
  const showHeader = !isFiltering || teams.length > 0
  const showAllScope = shouldShowAllScope(isFiltering, isMeetings, isAdminOrOwner)

  return (
    <MenuGroup data-component="scope-dropdown-team-list">
      {showHeader && (
        <Header
          scope="team"
          showNewLink={canCreateTeam}
        />
      )}
      {showAllScope && (
        <AllScope
          scope="all_teams"
          onClick={() => selectItem('page')}
        />
      )}
      {teams.map(({ id, name, ...item }) => (
        <Item
          key={id}
          itemId={id}
          avatarLetter={item.avatar_letter}
          avatarUrl={item.avatar_url}
          onClick={() => selectItem('page_single', id)}
          filterTerm={filterTerm}
        >
          {name}
        </Item>
      ))}
      {hasMoreTeams && <ShowMore onClick={() => dispatch(loadMoreData('pages'))} />}
    </MenuGroup>
  )
}

export default TeamsList
